/**
 * RepositoryFactory.js
 *
 * Factory to define all API repositories
 *
 * @author     Ken van den Broek    <k.vandenbroek@uselab.com>
 * @copyright  Uselab Amsterdam
 *
 */

import AlbumRepository from './AlbumRepository';
import BicycleExemptionService from './BicycleExemptionService';
import HikingTrailsRepository from './HikingTrailsRepository';
import PoisRepository from './PoisRepository';
import Pro6PPRepository from './Pro6PPRepository';
import UserRepository from './UserRepository';

const repositories = {
  album: AlbumRepository,
  'bicycle-exemption': BicycleExemptionService,
  'hiking-trails': HikingTrailsRepository,
  pois: PoisRepository,
  pro6pp: Pro6PPRepository,
  user: UserRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
